import { render, staticRenderFns } from "./ProjectShow.vue?vue&type=template&id=31150fd4&scoped=true&"
import script from "./ProjectShow.vue?vue&type=script&lang=js&"
export * from "./ProjectShow.vue?vue&type=script&lang=js&"
import style0 from "./ProjectShow.vue?vue&type=style&index=0&id=31150fd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31150fd4",
  null
  
)

export default component.exports